<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <v-flex d-flex align-center justify-space-between>
            <h1 class="headline">
              {{ $t('driverBalance.title') }} - {{ driverName }}
            </h1>

            <div>
              <v-btn
                v-if="$can('driver_edit_transactions')"
                type="submit"
                class="mr-3"
                color="warning"
                large
                depressed
                @click="
                  () => {
                    updateBalance.dialog = true;
                    updateBalance.type = 'increase';
                    updateBalance.editData = null;
                  }
                "
                >{{ $t('common.btns.increaseBalance') }}
              </v-btn>

              <v-btn
                v-if="$can('driver_edit_transactions')"
                type="submit"
                color="error"
                large
                depressed
                @click="
                  () => {
                    updateBalance.dialog = true;
                    updateBalance.type = 'decrease';
                    updateBalance.editData = null;
                  }
                "
                >{{ $t('common.btns.decreaseBalance') }}</v-btn
              >
            </div>
          </v-flex>
          <div
            v-if="dataIsLoading"
            class="progress d-flex justify-center align-center mt-4"
          >
            <v-progress-circular :size="70" color="warning" indeterminate />
          </div>
          <v-layout wrap align-center v-if="!dataIsLoading">
            <v-flex xs12>
              <!-- Driver balance -->
              <div class="title">
                {{ $t('driverBalance.balance') }}:
                <span class="warning--text"
                  >{{ balance }} {{ $t('driverBalance.currency') }}</span
                >
              </div>

              <!-- Driver transactions table -->
              <driver-transactions
                @show-snack="
                  (data) => {
                    snack = { opened: true, ...data };
                  }
                "
                @edit-transaction="
                  ({ isNumberPositive, data }) => {
                    updateBalance.dialog = true;
                    updateBalance.editData = data;
                    updateBalance.type = isNumberPositive
                      ? 'increase'
                      : 'decrease';
                  }
                "
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>

    <update-balance-dialog
      v-model="updateBalance.dialog"
      :type="updateBalance.type"
      :edit-data="updateBalance.editData"
      @updated="processResult"
    />

    <v-snackbar v-model="snack.opened" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import DriverTransactions from '@/components/driver/DriverTransactions.vue';
import UpdateBalanceDialog from '@/components/user/UpdateBalanceDialog.vue';

export default {
  name: 'DriverBalancePage',
  components: {
    DriverTransactions,
    UpdateBalanceDialog,
  },
  data() {
    return {
      dataIsLoading: false,
      updateBalance: {
        dialog: false,
        type: 'increase',
        editData: null,
      },

      snack: {
        opened: false,
        message: '',
        color: '',
      },
    };
  },
  computed: {
    ...mapGetters({
      successAlert: 'global/getAlertSuccess',
      isLoading: 'global/getLoader',
      balance: 'driver/getDriverBalance',
      driverName: 'driver/getDriverName',
    }),
  },
  async created() {
    this.dataIsLoading = true;
    try {
      await this.fetchDriverTransactions({
        driverId: this.$route.params.driverId,
      });
      this.dataIsLoading = false;
    } catch (error) {
      if (error.status === 404) {
        this.$router.push({ name: 'not-found' });
        return;
      }
      this.dataIsLoading = false;
    }
  },
  destroyed() {
    this.clearAlertError();
    this.clearAlertSuccess();
    this.setDriverTransactionsData({});
    this.setDriverBalance(null);
    this.setUserId(null);
  },
  methods: {
    ...mapActions({
      fetchDriverTransactions: 'driver/fetchDriverTransactionsData',
    }),
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
      clearAlertSuccess: 'global/clearAlertSuccess',
      setLoader: 'global/setLoader',
      setDriverBalance: 'driver/setDriverBalance',
      setUserId: 'user/setUserId',
      setDriverTransactionsData: 'driver/setDriverTransactionsData',
    }),
    processResult({ success, message }) {
      if (success) {
        this.snack.color = 'success';
        this.snack.message = message;
        this.snack.opened = true;

        this.fetchDriverTransactions({
          driverId: this.$route.params.driverId,
        });
      } else {
        this.snack.color = 'error';
        this.snack.message = message;
        this.snack.opened = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
